import * as React from 'react';
import cn from 'clsx';
import { Image } from '@cian/ui-kit';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../../../constants/mediaQueries';
import { withDeviceType, IWithDeviceTypeProps } from '../../../../utils/withDeviceType';
import { B_CLIENT_ICONS, C_CLIENT_ICONS } from '../../constants';

import * as styles from './styles.css';

interface IClientTypeToggleProps extends IWithDeviceTypeProps {
  b2cPromoUrl: string;
  onLinkClick(): void;
}

const ClientTypeToggle: React.FC<React.PropsWithChildren<IClientTypeToggleProps>> = ({
  b2cPromoUrl,
  isPhone,
  onLinkClick,
}) => {
  const iconSize = isPhone ? 24 : 40;

  return (
    <div className={cn(styles['container'], { [styles['phone']]: isPhone })}>
      <div className={cn(styles['toggle-button'], styles['active'], { [styles['phone']]: isPhone })}>
        <Image
          width={iconSize}
          height={iconSize}
          sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: B_CLIENT_ICONS.x2 }, { srcset: B_CLIENT_ICONS.x1 }]}
          src={B_CLIENT_ICONS.x1}
        />
        <div className={cn(styles['text'], styles['inactive'], { [styles['phone']]: isPhone })}>
          {isPhone ? 'Я риелтор' : 'Веду сделку как риелтор'}
        </div>
      </div>
      <a
        className={cn(styles['toggle-button'], styles['inactive'], { [styles['phone']]: isPhone })}
        href={b2cPromoUrl}
        onClick={onLinkClick}
      >
        <Image
          width={iconSize}
          height={iconSize}
          sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: C_CLIENT_ICONS.x2 }, { srcset: C_CLIENT_ICONS.x1 }]}
          src={C_CLIENT_ICONS.x1}
        />
        <div className={cn(styles['text'], styles['inactive'], { [styles['phone']]: isPhone })}>
          <span>{isPhone ? 'Я покупатель/продавец' : 'Я покупатель / продавец'}</span>
        </div>
      </a>
    </div>
  );
};

const ClientTypeToggleWithDeviceType = withDeviceType(ClientTypeToggle);
export { ClientTypeToggleWithDeviceType as ClientTypeToggle };
